import React, {useEffect, useState, useRef} from 'react';
import PropTypes from "prop-types";
import JustValidate from 'just-validate';

export default function CsfMemberDeleteActivitiesModal({selectedActivity, activitiesDataLayer}){
  const [isError, setIsError] = useState(false);
  const dismissButton = useRef();
  const [recognitionNumber, setRecognitionNumber] = useState("");
  const [idToDelete, setIsToDelete] = useState("");
  const [validator, setValidator] = useState(null);
  const selectedActivityRef = useRef();

  useEffect(() => {
    if (selectedActivity?.Recognition_Code) {
      selectedActivityRef.current = selectedActivity;
    }
    setRecognitionNumber(selectedActivityRef.current?.Recognition_Code);
    setIsToDelete(selectedActivityRef.current?.GSFT_Attendance_View_Id);
  }, [selectedActivity]);

  /*
  * Setup form validation
  * */
  useEffect(() => {
    const validator = new JustValidate('#membreDeleteActivitiesModal');

    validator
      .addField('#activities-confirm-reco', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ])
    setValidator(validator);

    return () => validator.destroy();
  }, []);

  function deleteActivity(e) {
    e.preventDefault()

    if (validator) {
      validator.validate();
      setTimeout(() => {
        if (validator?.isValid) {
          activitiesDataLayer.deleteActivity(idToDelete, setIsError);
          window.location.reload();
        } else {
          console.error('Form validation failed!');
        }
      });
    }
  }

  return (
    <div className="modal fade" id="membreDeleteActivitiesModal" tabIndex="-1" role="dialog" aria-labelledby="membreDeleteActivitiesModalTitle"
    aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <form className="modal-content" onSubmit={deleteActivity}>
        <div className="modal-header d-flex align-items-center">
          <h2 id="membreDeleteActivitiesModalTitle">{window.Drupal.t('membre.activities.modal.delete.title')}</h2>
          <button type="button" className="close" data-dismiss="modal" ref={dismissButton}
                  aria-label={window.Drupal.t('lang.modal.close')}>
            <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
          </button>
        </div>

        <div className="modal-body">
          {isError === true && (
            <div className="alert alert-danger" role="alert"
              aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
          )}
          <div className="row">
            <div className="col-12">
              <div className="form-group date">
                <label htmlFor="activities-confirm-reco">{window.Drupal.t('membre.activity.modal.confirmReco.label')}*</label>
                <input
                  type="text"
                  id="activities-confirm-reco"
                  name="activities-confirm-reco"
                  defaultValue={recognitionNumber}
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="mt-1">
            <p className="m-0 larger-text text-center"
              dangerouslySetInnerHTML={{ __html: `${window.Drupal.t('membre.activities.modal.delete.warning')}<br />«&nbsp;${selectedActivityRef.current?.Activite_Id__Rn_Descriptor}&nbsp;» ?`}}></p>
          </div>
        </div>

        <div className="modal-footer">
            <div className="space-between-wrapper">
              <button type="button" className='button btn-pale btn-larger' data-dismiss="modal">{window.Drupal.t('fournisseur.back.btn')}</button>
              <input className="btn-submit btn-red btn-larger" type="submit" value={window.Drupal.t('membre.activities.modal.delete.button')}/>
            </div>
          </div>
      </form>
    </div>
  </div>
  )
}

CsfMemberDeleteActivitiesModal.propTypes = {
  selectedActivity: PropTypes.object,
  activitiesDataLayer: PropTypes.object,
};
